import axios from './axios';
import qs from 'qs'
/* 质检机构 */
export function fetchExpertInfo(query) {
    return axios({
        url: 'https://www.zbtesting.com/V4Interface/Expert/pmList',
        method: 'get',
        params: query
    })
}

/* 证书查询 */
export function fetchCertificate(query) {
    return axios({
        url: 'https://www.zbtesting.com/Api/GemQurey/v4',
        method: 'get',
        params: query
    })
}

/* 证书查询v5 */
export function certificate(query) {
    return axios({
        url: 'https://v5.zbtesting.com/v1/gem/search',
        method: 'get',
        params: query
    })
}

/* 专家页面 */
export function fetchQualityStation(query) {
    return axios({
        url: 'https://www.zbtesting.com/V4Interface/Gem/pmStation',
        method: 'get',
        params: query
    })
}
/* 专家入驻 */
export function postExpertsIn(obj) {
    return axios({
        url: 'https://www.zbtesting.com/V4Interface/Expert/pmAdd',
        method: 'post',
        data: qs.stringify(obj)
    })
}
// 今日金价
export function fetchPmlist(query) {
    return axios({
        url: 'https://www.zbtesting.com/V4Interface/Gold/pmlist',
        method: 'get',
        params: query   
    })
}
// 珠宝百科
export function fetchBaikeDetails(query) {
    return axios({
        url: 'https://www.zbtesting.com/V4Interface/Baike/pmDetails',
        method: 'get',
        params: query
    })
}   
// 行业讯息
export function fetchNewspmList(query) {
    return axios({
        url: 'https://www.zbtesting.com/V4Interface/News/pmList',
        method: 'post',
        params: query
    })
}
// 行业讯息详细
export function fetchNewsPmDetails(query) {
    return axios({
        url: 'https://www.zbtesting.com/V4Interface/News/pmDetails',
        method: 'post',
        params: query
    })
}
// 行业讯息 v5
export function newsList(query) {
    return axios({
        url: 'https://v5.zbtesting.com/v1/news/lists',
        method: 'get',
        params: query
    })
}
// 行业讯息详细 v5
export function news(query) {
    return axios({
        url: 'https://v5.zbtesting.com/v1/news/page',
        method: 'get',
        params: query
    })
}
/* 专家列表 v5 */
export function experts(query) {
    return axios({
        url: 'https://v5.zbtesting.com/v1/expert/lists',
        method: 'get',
        params: query
    })
}
/* 检测站列表 v5 */
export function stationList(query) {
    return axios({
        url: 'https://v5.zbtesting.com/v1/station/search',
        method: 'get',
        params: query
    })
}
/* 今日金价 v5 */
export function goldPrice(query) {
    return axios({
        url: 'https://v5.zbtesting.com/v1/Gold/priceList',
        method: 'get',
        params: query
    })
}
/* 钻石查询 v5 */
export function diamondList(query) {
    return axios({
        url: 'https://v5.zbtesting.com/v1/diamon/exgemLists',
        method: 'get',
        params: query
    })
}
/* banner列表 v5 */
export function bannerList(query) {
    return axios({
        url: 'https://v5.zbtesting.com/v1/advert/lists',
        method: 'get',
        params: query
    })
}